import "./InternationalLocations.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import DeliveryModel from "./sections/DeliveryModel";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function InternationalLocationsPage() {
  return <div>
      <Header />
      <Hero />
      <DeliveryModel />
      <Consultation />
      <Footer />
    </div>;
}